import moment from 'moment';
import React from 'react';
import { Link } from 'react-router-dom';

import { Wws_PurchaseDomain } from '../../generated/graphql';
import { purchaseDomainRenewalRoute } from '../../helpers/routes';
import rightContainerStyles from '../rightContainer.scss';

interface Props {
  domain?: Wws_PurchaseDomain;
}

const getRenewalCountdown = (
  expirationDate?: string | null,
  isExpired?: boolean | undefined,
  showRenewal?: boolean | undefined
) => {
  const startDay = moment(Date.now()).startOf('day');
  const expirationDateTs = moment(expirationDate || undefined, 'YYYY-MM-DD');
  const delta = expirationDateTs.diff(startDay, 'day');

  if (isExpired) return 'has expired. Click here to';
  if (showRenewal) return `expires in ${delta} day${delta > 1 ? 's' : ''}.`;
  return `expires on ${expirationDateTs.format('MM/DD/YYYY')}.`;
};

const CustomDomainInformation: React.FC<Props> = ({ domain }) => {
  const { expirationDate, isExpired, showRenewal } = domain || {};
  const renewalMessage = getRenewalCountdown(expirationDate, isExpired || false, showRenewal || false);

  return (
    <>
      <div className={rightContainerStyles.domain}>Your custom website URL {renewalMessage}</div>
      {showRenewal && <Link to={purchaseDomainRenewalRoute}>Renew.</Link>}
    </>
  );
};

export default CustomDomainInformation;
